import io from 'socket.io-client';
import config from '../config'

const socket = io(config.api_url); // URL del servidor de Socket.IO

export default socket;